<template>
  <div class="amenity notranslate toCapitalize">
    <div class="category toUppercase">
      <div class="categoryBox">
        <button type="button"
          v-for="cate in amenityCategory"
          :key="cate"
          :class="{active: cate === category}"
          :style="cate === category && { ...skinStyle('amenityActivate', 'border-color') }"
          @click="setCategory(cate)"
          v-html="getCategoryName(cate)">
        </button>
      </div>
    </div>
    <div
      v-if="isAvailable !== null"
      class="availableBox"
      :data-state="isAvailable ? '01' : '02'">
      <span class="message" @click="onTableOpen">
        <i></i> {{availableMessage}}
      </span>
      <em v-if="isAvailable === false" @click="onTableOpen">{{locale.available_time}}</em>
    </div>
    <AmenityList
      v-if="amenity.length"
      :lang="lang"
      :list="amenity"
      :loadData="loadData"
      :locale="locale"
      :localeAmenity="localeAmenity"
      :roomKey="roomKey" />
    <p v-else class="noData">{{loadData ? locale.amenity_nodata : locale.data_loading}}</p>
    <div v-if="amenityRequest.length > 0" class="btnSubmit">
      <div v-if="requestPossible.limit && requestPossible.limit < requestPossible.request" class="message">
        <!-- <p v-if="requestPossible.cart">현재 장바구니에 {{requestPossible.cart}}개가 담겨있습니다.</p> -->
        <!-- 어메니티는 최대 {{requestPossible.limit}}개 항목까지 요청 가능합니다. -->
        {{limitMessage()}}
      </div>
      <button type="button" class="btn btnFull"
        @click.stop="onConfirm"
        :disabled="!roomKey || (requestPossible.limit && requestPossible.limit < requestPossible.request) || isAvailable === false"
        :style="getPointColorsMultiple([
          {target: 'amenityBtn', attr: 'background-color'},
          {target: 'amenityBtnText', attr: 'color'}
        ])">
        {{locale.amenity_request}}
      </button>
    </div>
    <Summary v-if="summaryData !== null"
      :lang="lang"
      :locale="locale"
      :localeAmenity="localeAmenity"
      :roomKey="roomKey"
      :summary="summaryData"
      :price="requestPrice"
      :requestPossible="requestPossible"
      @confirm="confirmSummary" />
    <AvailableTable
      v-if="availableTable"
      :locale="locale"
      :table="amenitySetting.available.set"
      :style="{zIndex: 99999}"
      @close="onTableClose" />
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import UNIQUE from '@/common/unique'
import AmenityList from '@/components/Amenity/AmenityList.vue'
import Summary from '@/components/Amenity/Summary.vue'
import AvailableTable from '@/components/Util/AvailableTable'
import Toast from '@/components/Util/Toast'

export default {
  name: 'Amenity',
  props: [
    'lang',
    'locale',
    'roomKey'
  ],
  components: {
    AmenityList,
    Summary,
    AvailableTable,
    Toast
  },
  computed: {
    ...mapGetters({
      getAuthInfo: 'authentication/getAuthInfo',
      amenityList: 'amenity/getAmenityList',
      amenityOrder: 'amenity/getAmenityOrder',
      getAmenityCategory: 'amenity/getAmenityCategory',
      getAmenityRequest: 'amenity/getAmenityRequest',
      amenitySetting: 'amenity/getAmenitySetting',
      getTax: 'payment/getTax',
      pointColors: 'common/getPointColors',
      getAvailableDay: 'util/getAvailableDay',
      getSetting: 'common/getSetting',
      getPointColorsMultiple: 'common/getPointColorsMultiple'
    }),
    localeAmenity () {
      return this.$store.state.system.localeAmenity.data
    },
    tax () {
      return this.$store.state.payment.tax
    },
    integVer () {
      return this.amenitySetting.integration // 통합버전(system_amenity2)
    },
    amenityRequest () {
      const taxPer = this.tax
      return this.getAmenityRequest.map(x => {
        return {
          ...x,
          ...x.price && {
            total: x.price * x.count,
            ...taxPer && {
              subtotal: x.price * x.count,
              tax: this.getTax(x.price * x.count),
              taxLabel: `${taxPer}%`,
              total: x.price * x.count + this.getTax(x.price * x.count)
            }
          }
        }
      })
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    isPublic () {
      return this.getAuthInfo.public === 'true'
    },
    amenity () {
      const order = this.amenityOrder || [] // 순서변경 데이터 (순서만 관여)
      const ordered = this.order
      const list = this.amenityList.filter(x => x.service).map(x => {
        const orderedItem = ordered.filter(o => o.raCode === x.raCode)
        return {
          ...x,
          ...x.label && {
            label: x.label
          },
          price: x.price && parseFloat(x.price) >= 0 ? parseFloat(x.price) : 0,
          // 오늘 요청한 갯수
          orderedToday: orderedItem.filter(t => this.get1dayOrders(t.date)).map(t => t.count).reduce((a, b) => {
            return a + b
          }, 0),
          // 투숙중 요청한 갯수
          orderedOta: orderedItem.map(t => t.count).reduce((a, b) => {
            return a + b
          }, 0),
          orderedCountToday: orderedItem.filter(t => this.get1dayOrders(t.date)).length,
          orderedCountOta: orderedItem.length
        }
      })
      const category = this.category
      const orderList = order.map((x, i) => {
        return {
          index: i,
          raCode: x.raCode
        }
      })
      function getListInfo (arr) {
        function sortByOrder (list) {
          return list.sort(function (a, b) {
            return a.index === -1 ? 2 : a.index < b.index ? -1 : a.index > b.index ? 1 : 0
          })
        }
        const listIndex = arr.map(item => {
          const raCode = item.raCode
          const orderItem = orderList.find(x => x.raCode === raCode)
          return {
            ...item,
            index: orderItem ? orderItem.index : -1
          }
        })
        return sortByOrder(listIndex)
      }
      return getListInfo(list).filter(x => x.category === category)
    },
    amenityCategory () {
      const category = this.getAmenityCategory
      const items = this.amenityList.filter(x => x.service)
      return category.filter(x => {
        return items.find(i => i.category === x)
      })
    },
    // 요청 가능한 횟수
    orderMax () {
      const orderMax = this.amenitySetting && this.amenitySetting.itemLimitActive && this.amenitySetting.orderMax
      return orderMax
    },
    itemLimit () {
      const limit = this.amenitySetting && this.amenitySetting.itemLimitActive && this.amenitySetting.itemLimit
      return limit
    },
    requestPossible () {
      const orderLimit = this.amenitySetting && this.amenitySetting.itemLimitActive && this.amenitySetting.orderLimit
      const limit = this.itemLimit && this.itemLimit
      const request = this.amenityRequest.length
      const requestIds = this.amenityRequest.map(x => x.item)
      const cart = this.cartList.find(x => x.cartId === `cart_${this.$store.state.authentication.site}_amenity`)
        ? this.cartList.find(x => x.cartId === `cart_${this.$store.state.authentication.site}_amenity`).items.filter(x => {
          return !requestIds.includes(x.item)
        }).length
        : 0
      const orderMax = this.orderMax
      const todayOrder = this.order.filter(x => this.get1dayOrders(x.date)).length
      const otaOrder = this.order.length
      const remainOrder = orderMax
        ? orderLimit === 'day'
          ? getOrderMax(orderMax, todayOrder)
          : getOrderMax(orderMax, otaOrder)
        : null
      function getOrderMax (max, order) {
        return max - order <= 0 ? 0 : max - order
      }
      return {
        limit: limit,
        cart: cart,
        request: request,
        orderMax: orderMax,
        remainOrder: remainOrder,
        isPossible: (limit && request + cart <= limit) || remainOrder <= 0,
        orderLimit: orderLimit,
        isPossibleCart: limit ? request + cart <= limit : true,
        requestIds: requestIds
        // isPossibleOrderMax: remainOrder > 0
      }
    },
    requestPrice () {
      const request = this.amenityRequest.filter(x => x.price)
      const currency = this.$store.state.common.setting.currency.toUpperCase()
      const total = request && request.length ? request.map(x => {
        return x.price * x.count
      }).reduce((a, b) => a + b) : 0
      const taxPer = this.tax
      const tax = this.getTax(total)
      const taxTotal = total + tax
      return total > 0 ? {
        info: {
          currency: currency,
          price: null,
          quantity: null,
          sum: total,
          total: total,
          ...taxPer && {
            subtotal: total,
            tax: tax,
            taxLabel: `${taxPer}%`,
            total: taxTotal
          }
        },
        option: request.filter(x => x.price).map(x => {
          return {
            ...x,
            quantity: x.count,
            total: x.price * x.count,
            ...taxPer && {
              subtotal: x.price * x.count,
              tax: this.getTax(x.price * x.count),
              total: x.price * x.count + this.getTax(x.price * x.count)
            }
          }
        })
      } : null
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      loadData: false,
      space: this.$store.state.authentication.space,
      key: this.$store.state.authentication.k,
      category: 'room',
      summaryData: null,
      submitData: {
        submitId: 'system_amenity',
        catCode: 'system_amenity'
      },
      isConfirmed: false,
      cartList: [],
      order: [],
      isAvailable: null,
      checkAvailable: 0,
      availableMessage: '',
      availableTable: false,
      toastList: []
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'amenity'
      })
    },
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    skinStyleMultiple (arr) {
      return this.getPointColorsMultiple(arr)
    },
    async init () {
      this.category = 'room'
      this.isAvailable = null
      this.$store.commit('amenity/initRequest')
      this.getAmenityList().then(() => {
        this.loadData = true
        this.getOrderAmenity()
      })
      this.getCartList()
      this.track()
    },
    checkAvailableTime () {
      const setting = this.amenitySetting
      function timeMessage (arr) {
        arr = arr.map(x => {
          return `${x.from} ~ ${x.to}`
        })
        return arr.join(' / ')
      }
      this.checkAvailable = setInterval(() => {
        const available = setting.available // submit 데이터
        const isAlways = available.state === '01' // 01 ? always : each
        const today = moment().isoWeekday() - 1
        const day = available.set[today]
        const check = this.getAvailableDay(day)
        const isAvailable = isAlways
          ? null
          : check
        this.isAvailable = isAvailable
        this.availableMessage = !check ? this.locale.not_available : timeMessage(day.time)
      }, 1000)
    },
    onTableOpen () {
      this.availableTable = true
    },
    onTableClose () {
      this.availableTable = false
    },
    limitMessage () {
      const limit = this.requestPossible.limit
      const message = this.locale.amenity_item_limit.replace('{var}', limit)
      return message
    },
    // 요청제한을 위한 어메니티 요청 히스토리 조회
    getOrderAmenity () {
      function getOrderList (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          for (let j = 0; j < item.ordersheet.length; j++) {
            const ordersheet = item.ordersheet[j]
            result.push({ ...ordersheet, date: item.date })
          }
        }
        return result
      }
      const isIntegVer = this.integVer
      this.$store.commit('loading', true)
      this.$store.dispatch('submit/getOrderHistory').then((res) => {
        if (res && res.orderLog) {
          const orders = res.orderLog.filter(x => {
            const orderType = isIntegVer ? 'system_amenity_v2' : 'system_amenity'
            return x.order_type === orderType && !x.cancelled
          }).map(x => {
            return {
              ordersheet: isIntegVer
                ? !x.ordersheet.items || x.ordersheet.length
                  ? x.ordersheet[0].items
                  : x.ordersheet.items
                : x.ordersheet,
              date: x.createat
            }
          })
          this.order = getOrderList(orders).map(x => {
            return {
              ...x,
              raCode: x.item
            }
          })
        }
        this.$store.commit('loading', false)
      })
    },
    getCategoryName (cate) {
      const category = `amenity_category_${cate}`
      const categoryName = this.locale[category]
      return categoryName.toUpperCase()
    },
    async getAmenityList () {
      const res = await this.$store.dispatch('amenity/getAmenity')
      this.category = this.amenityCategory
        ? this.amenityCategory[0]
        : ''
      this.submitData.submitId = this.integVer ? 'system_amenity_v2' : 'system_amenity'
      if (this.integVer) {
        this.submitData = {
          ...this.submitData,
          catCode: 'system_amenity_v2',
          categoryLabel: 'Amenity'
        }
      }
      if (res.setting && res.setting.available) {
        this.checkAvailableTime()
      }
    },
    get1dayOrders (iso) {
      const timezone = this.timezone
      const time = this.amenitySetting.limitTime || '12:00' // 설정한 리셋시간
      const hh = time.split(':')[0]
      const mm = time.split(':')[1]
      const now = moment()
      const today = moment().set({ hour: hh, moment: mm, second: 0 }).tz(timezone).toISOString()
      const yesterday = moment().set({ hour: hh, moment: mm, second: 0 }).add(-1, 'days').tz(timezone).toISOString()
      const tomorrow = moment().set({ hour: hh, moment: mm, second: 0 }).add(1, 'days').tz(timezone).toISOString()
      return now.isSameOrBefore(today)
        ? moment(iso).tz(timezone).isBetween(yesterday, today)
        : moment(iso).tz(timezone).isBetween(today, tomorrow)
    },
    setCategory (category) {
      this.category = category
    },
    onConfirm () {
      const submitAt = new Date().toISOString()
      this.summaryData = {
        submitAt: submitAt,
        items: this.amenityRequest
      }
      this.submitData.submitAt = submitAt
    },
    addToast (trigger, type, message) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message
      }
      this.toastList.push(toast)
      // this.summaryData = null
    },
    delToast (id) {
      this.toastList = this.toastList.filter(x => x.id !== id)
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        if (trigger === 'goCartPage') {
          window.location.reload()
        }
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'addCart') {
            this.addCartItem(data.id)
          } else if (trigger === 'addCartExist') {
            this.addCartItemExist(data.id)
          } else if (trigger === 'goCartPage') {
            this.goCartPage(data.id)
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    confirmSummary (isConfirmed) {
      this.isConfirmed = isConfirmed
      this.onSubmit(isConfirmed)
      if (!isConfirmed) {
        this.summaryData = null
      }
    },
    getCartList () {
      this.cartList = []
      if (localStorage.length > 0) {
        for (let i = 0; i < localStorage.length; i++) {
          // cart_로 시작하는 items
          if (localStorage.key(i).includes('cart_')) {
            const cartItem = JSON.parse(localStorage.getItem(localStorage.key(i)))
            this.cartList.push({ ...cartItem, cartId: localStorage.key(i) })
          }
        }
      }
    },
    async addCartItem (id) {
      const ota = this.$store.state.authentication.k
      const lang = this.$route.params.ln
      const isFrame = this.isPublic ? '&frame=false' : ''
      const integVer = this.integVer
      const returnURL = `${window.location.origin}${window.location.pathname}${window.location.search}${isFrame}#/${lang}/complete`
      const langObj = this.$store.state.common.setting.lang.info
      const subject = function (langObj, val) {
        let obj = {}
        langObj.map(x => {
          obj[x.c] = val || ''
        })
        return obj
      }
      const submitData = Object.assign({
        ...this.submitData,
        ...this.requestPrice && {
          price: this.requestPrice,
          returnURL: returnURL
        },
        items: this.amenityRequest,
        price: {
          ...this.requestPrice || {
            info: {
              currency: this.$store.state.common.setting.currency.toUpperCase(),
              price: 0,
              quantity: 0,
              sum: 0,
              total: 0
            },
            option: null
          }
        },
        // 어메니티 v2
        ...integVer && {
          title: this.amenityRequest.map(x => {
            return `${x.item}*${x.count}`
          }).join(','),
          content: this.amenityRequest.map(x => {
            return {
              item: x.item,
              label: x.label || x.item,
              value: x.count,
              count: x.count,
              quantity: x.count,
              ...x.price && {
                price: x.price,
                ...this.tax && {
                  subtotal: x.price * x.count,
                  tax: this.getTax(x.price * x.count),
                  total: x.price * x.count + this.getTax(x.price * x.count)
                }
              },
              ...x.pid && {
                pid: x.pid
              }
            }
          }),
          info: {
            subject: subject(langObj, 'amenity'),
            thumb: ''
          }
        }
      })
      const cartId = `cart_${this.$store.state.authentication.site}_amenity`
      const cartItem = {
        cartId: cartId,
        cartOta: ota,
        ...submitData
      }
      const cartContent = JSON.stringify(cartItem)
      localStorage.setItem(cartId, cartContent)
      this.$store.commit('loading', true)
      this.$store.commit('cart/addList', cartItem)
      this.delToast(id)
      this.addToast('goCartPage', 'confirm', `${this.locale.complete_cart_add}\n${this.locale.confirm_cart_page}`)
      this.$store.commit('loading', false)
    },
    addCartItemExist (id) {
      const cartList = this.cartList
      const integVer = this.integVer
      const cartAmenity = cartList.find(x => x.cartId === `cart_${this.$store.state.authentication.site}_amenity`) // 장바구니에 어메니티가 있고
      const cartItemIds = cartAmenity.items.map(x => x.item)
      const cartItems = cartAmenity.items.map(x => {
        const item = this.amenityRequest.find(r => r.item === x.item)
        return {
          ...x,
          count: item ? x.count + item.count : x.count
        }
      }) || []
      const cartId = `cart_${this.$store.state.authentication.site}_amenity`
      const others = this.amenityRequest.filter(x => !cartItemIds.includes(x.item)) || []
      const merge = cartItems.concat(others)
      const priceItemsTotal = merge.filter(x => x.price).length > 0
        ? merge.filter(x => x.price).map(x => x.price * x.count).reduce((a, b) => a + b)
        : 0
      const existCartItem = {
        ...cartAmenity,
        items: merge,
        ...integVer && {
          content: cartItems.map(x => {
            return {
              item: x.item,
              count: x.count,
              label: x.label || x.item,
              value: x.count,
              ...x.price && {
                price: x.price
              }
            }
          }),
          price: {
            info: {
              currency: this.$store.state.common.setting.currency.toUpperCase(),
              price: null,
              quantity: null,
              sum: priceItemsTotal,
              total: priceItemsTotal
            },
            option: merge.filter(x => x.price)
          }
        }
      }
      // return false
      const existCartContent = JSON.stringify(existCartItem)
      localStorage.setItem(cartId, existCartContent)
      this.$store.commit('cart/addList', existCartItem)
      this.addToast('goCartPage', 'confirm', `${this.locale.complete_cart_add}\n${this.locale.confirm_cart_page}`)
    },
    goCartPage (id) {
      const lang = this.lang
      this.delToast(id)
      this.$router.push({ name: 'cart', params: { lang: lang } })
    },
    async onSubmit (submit) {
      const lang = this.$route.params.ln
      const isFrame = this.isPublic ? '&frame=false' : ''
      const integVer = this.integVer
      const returnURL = `${window.location.origin}${window.location.pathname}${window.location.search}${isFrame}#/${lang}/complete`
      const langObj = this.$store.state.common.setting.lang.info
      const subject = function (langObj, val) {
        let obj = {}
        langObj.map(x => {
          obj[x.c] = val || ''
        })
        return obj
      }
      const submitData = Object.assign({
        ...this.submitData,
        ...this.requestPrice && {
          price: this.requestPrice,
          returnURL: returnURL
        },
        items: this.amenityRequest,
        price: {
          ...this.requestPrice || {
            info: {
              currency: this.$store.state.common.setting.currency.toUpperCase(),
              price: 0,
              quantity: 0,
              sum: 0,
              total: 0
            },
            option: null
          }
        },
        // 어메니티 v2
        ...integVer && {
          title: this.amenityRequest.map(x => {
            return `${x.item}*${x.count}`
          }).join(','),
          content: this.amenityRequest.map(x => {
            return {
              item: x.item,
              label: x.label || x.item,
              value: x.count,
              count: x.count,
              quantity: x.count,
              ...x.price && {
                price: x.price,
                ...this.tax && {
                  subtotal: x.price * x.count,
                  tax: this.getTax(x.price * x.count),
                  total: x.price * x.count + this.getTax(x.price * x.count)
                }
              },
              ...x.pid && {
                pid: x.pid
              }
            }
          }),
          info: {
            subject: subject(langObj, 'amenity'),
            thumb: ''
          }
        }
      })
      const submitItems = this.amenityRequest
      const submitAmenityData = integVer ? {
        isArray: true,
        payload: [submitData],
        price: submitData.price,
        returnURL: returnURL
      } : submitData
      if (submit === 'request') {
        this.$store.commit('loading', true)
        this.$store.dispatch('submit/setSubmit', submitAmenityData).then((res) => {
          if (res && res.status && res.status === 200) {
            const payment = this.requestPrice && res.payment
            if (payment) {
              const paymentId = res.paymentId
              const routerName = res.roomCharge ? 'paymentStep' : 'payment'
              this.$router.push({ name: routerName, params: { ln: lang, payment: payment, paymentId: paymentId } })
              this.$store.commit('loading', false)
            } else {
              // center로 바로 요청
              this.$router.push({ name: 'complete', params: { ln: lang } })
              this.$store.commit('loading', false)
            }
          } else {
            if (res.message && res.message.length) {
              if (res.message.includes('Unauthorized')) {
                alert(this.locale.invalid_key)
                window.location.reload()
              } else {
                // 시스템에러가 발생했습니다.
                alert(this.locale.alert_system_error)
              }
            } else {
              // 시스템에러가 발생했습니다.
              alert(this.locale.alert_system_error)
            }
            this.$store.commit('loading', false)
          }
        })
      } else if (submit === 'cart') {
        const cartList = this.cartList
        const cartAmenity = cartList.find(x => x.cartId === `cart_${this.$store.state.authentication.site}_amenity`) // 장바구니에 어메니티가 있고
        const cartAmenityItems = cartAmenity // 장바구니에 선택한 어메니티 항목이 있는지 체크
          ? cartAmenity.items.flat(Infinity).filter(x => submitItems.map(s => s.item).includes(x.item)).length > 0
          : false
        if (cartAmenity) { // 이미 장바구니에 상품이 존재할 때 기존 장바구니와 합친다
          if (cartAmenityItems) {
            this.addToast('addCartExist', 'confirm', `${this.locale.confirm_cart_add_already}\n${this.locale.confirm_cart_add}`)
          } else {
            this.addToast('addCartExist', 'confirm', this.locale.confirm_cart_add)
          }
        } else { // 새로 장바구니에 추가
          this.addToast('addCart', 'confirm', this.locale.confirm_cart_add)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.category {
  border-bottom: 1px solid $color-lgrey2;
  background-color: $color-white;
  box-shadow: 0 0 5px rgba(0,0,0,0.15);
  .categoryBox {
    display: flex;
    align-items: center;
    justify-content: center;
    @include container;
  }
  button {
    position: relative;
    flex: 1;
    height: 45px;
    & + button {
      opacity: 0.7;
    }
    &.active {
      font-weight: 700;
      border-color: $color-primary;
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-top: 4px solid $color-primary;
        border-top-color: inherit;
      }
    }
  }
}
.noData {
  padding: 2em 0;
  text-align: center;
  font-size: 1.2em;
}
.btnSubmit {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  font-weight: 700;
  border-top: 1px solid rgba(255,255,255,0.25);
  box-shadow: 0 0 10px rgba(0,0,0,0.25);
  z-index: 2;
  .message {
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-bottom: 10px;
    padding: 5px 10px;
    white-space: nowrap;
    font-size: 12px;
    font-weight: normal;
    color: $color-white;
    background-color: $color-red;
    border-radius: 8px;
    transform: translate(-50%, 0);
    &:before {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      width: 8px;
      height: 8px;
      margin-top: -4px;
      margin-left: -4px;
      background-color: $color-red;
      transform: rotate(45deg);
    }
  }
  .btn {
    border: none;
    border-top: 1px solid rgba(0,0,0,0.25);
  }
}
@media screen and (min-width: 768px) {
  .category {
    font-size: 20px;
    button {
      height: 60px;
    }
  }
  .btnSubmit {
    padding-left: 80px;
    .btn {
      font-size: 1.2em;
    }
  }
}
@media screen and (min-width: 800px) {
  .btnSubmit {
    padding-left: 180px;
  }
}
@media screen and (min-width: 1024px) {
  .btnSubmit {
    padding-left: 240px;
  }
  .amenity .list {
    padding: 30px 22px 60px;
  }
}
.availableBox {
  padding: 0.5em 15px;
  border-bottom: 1px solid $color-lgrey2;
  &[data-state="01"] i {
    background-color: $color-green;
  }
  &[data-state="02"] i {
    background-color: $color-red;
  }
  i {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color: $color-green;
  }
  .message {
    display: inline-block;
    padding: 0.3em 1em;
    font-size: 0.85em;
    color: $color-white;
    vertical-align: middle;
    border-radius: 3em;
    background-color: $color-dark;
  }
  em {
    display: inline-block;
    position: relative;
    margin-left: 6px;
    padding: 2px 4px;
    text-align: center;
    vertical-align: middle;
    font-size: 12px;
    font-weight: bold;
    font-family: 'arial';
    color: $color-white;
    border-radius: 4px;
    background-color: $color-red;
    cursor: pointer;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 6px;
      height: 6px;
      margin-top: -3px;
      margin-left: -3px;
      border-radius: 2px;
      background-color: $color-red;
      transform: rotate(45deg);
    }
  }
}
</style>
